import { Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import CustomSelect from "../../../../components/Select/Select";
import {
  getClinicStocks,
  getServices,
} from "../../../../redux/reducers/clinicSlice";
import {
  createPrescriptionWoLoader,
  createProcedure,
  getProceduresByPetId,
  updatePrescriptionByIdWoLoader,
  updateProcedureById,
  updateProcedureDateAndRemarkById,
} from "../../../../redux/reducers/petSlice";
import {
  radioActionScheduleOnly,
  radioActionTypes,
} from "../../../../util/arrayList";
import { datePlusOneDay, getProcedureDetails } from "../../../../util/function";

const nameExpan = {
  procedureName: "Procedure Name",
  category: "Category",
  subCategory: "Sub Category",
  remarks: "Remarks",
  status: "Status",
  extraStatus: "",
  doneAt: "Date",
  nextDueDate: "Next Due Date",
};
const initValues = {
  procedure: null,
  variant: null,
  date: new Date(),
  addToAppointment: false,
  remarks: "",
  nextDueDate: datePlusOneDay,
  nextDosage: false,
  actionType: "Schedule",
};

const PreventiveHistory = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { appointment } = location.state || {};
  const [modVsble, setModVsble] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [procedValues, setProcedValues] = useState(initValues);
  const [procedErrs, setProcedErrs] = useState({});
  const { procedure } = useSelector((state) => state?.pet);
  const {
    services,
    clinicStocks,
    details: clinicDet,
  } = useSelector((state) => state?.clinic);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const apntId =
    reqDet?.appointment?.appointmentId ??
    appointment?.appoinment?.appointmentId;

  useEffect(() => {
    dispatch(getServices());
    dispatch(getClinicStocks());
  }, []);

  const getProcedures = () => {
    dispatch(
      getProceduresByPetId({
        petId: reqDet?.appointment?.petId ?? appointment?.appoinment?.petId,
        url: "?page=1&itemSize=30",
      })
    );
  };

  const handleSuccess = () => {
    getProcedures();
    handleModClose();
  };

  const getVarinatList = (serId) => {
    if (!serId) return [];
    const reqList = services?.data
      ?.find((ser) => ser?.serviceId === serId)
      ?.serviceVariants?.map((vnt) => ({
        name: vnt?.variantName,
        variantId: vnt?.variantId,
        servicePrice: vnt?.servicePrice,
        value: vnt?.variantName,
        serviceCharge: vnt?.serviceCharge,
        variantNumber: vnt?.variantNumber,
        serviceId: serId,
      }));
    return reqList ?? [];
  };

  const onChange = (name, value) => {
    const reqObj = { ...procedValues, [name]: value };
    const errObj = { ...procedErrs };
    if (name === "procedure") {
      reqObj.procedure = value?.value;
      reqObj.serviceId = value?.serviceId;
      reqObj.category = value?.category;
      reqObj.subCategory = value?.subCategory;
      const vrnts = getVarinatList(value?.serviceId);
      reqObj.variant = vrnts?.[0]?.value;
      reqObj.variantId = vrnts?.[0]?.variantId;
      errObj.variant = "";
      errObj.procedure = "";
    }
    if (name === "variant") {
      reqObj.variant = value?.value;
      reqObj.variantId = value?.variantId;
      errObj.variant = "";
    }
    setProcedValues(reqObj);
    setProcedErrs(errObj);
  };

  const handleModClose = () => {
    setModVsble(false);
    setSelectedItem(null);
    setProcedValues(initValues);
    setProcedErrs({});
  };

  const getCost = (serId = null) => {
    if (!serId) return 0;
    let total = 0;
    const reqSer = services?.data?.find((ser) => ser?.serviceId === serId);
    if (reqSer) total = reqSer?.serviceVariants?.[0]?.servicePrice;
    return total;
  };

  const isValuesValid = () => {
    let errs = {};
    if (procedValues?.procedure?.length === 0 || !procedValues?.serviceId) {
      errs.procedure = "This field is required";
    }
    if (procedValues?.variant?.length === 0 || !procedValues?.variantId) {
      errs.variant = "This field is required";
    }
    setProcedErrs(errs);
    return Object.keys(errs)?.length > 0;
  };

  const handleSaveUpdate = () => {
    if (isValuesValid()) return;
    const data = {
      doneAt: moment(new Date(procedValues?.date)).format("YYYY-MM-DD"),
      remarks: procedValues?.remarks,
      procedureDetails: [],
      serviceType: procedValues?.variant,
      isFromPreventive: true,
      procedureVariantId: procedValues?.variantId,
    };
    if (!selectedItem) {
      data.procedureName = procedValues?.procedure;
      data.serviceId = procedValues?.serviceId;
      data.category = procedValues?.category;
      data.subCategory = procedValues?.subCategory;
      data.petId = appointment?.appoinment?.petId ?? procedValues?.petId;
      data.status = "Pending";
    }
    if (procedValues?.actionType === "Administer") {
      data.appointmentId = appointment?.appoinment?.appointmentId;
      data.procedureDetails = getProcedureDetails(
        procedValues?.serviceId,
        procedValues?.variantId,
        procedValues?.procedure,
        services?.data ?? [],
        clinicStocks?.data ?? [],
        clinicDet?.pharmacyTaxId
      ).procedureDetails;
      if (
        getProcedureDetails(
          procedValues?.serviceId,
          procedValues?.variantId,
          procedValues?.procedure,
          services?.data ?? [],
          clinicStocks?.data ?? [],
          clinicDet?.pharmacyTaxId
        )?.prescriptions?.length > 0
      ) {
        const data = {
          status: "Pending",
          remark: "",
          prescription: getProcedureDetails(
            procedValues?.serviceId,
            procedValues?.variantId,
            procedValues?.procedure,
            services?.data ?? [],
            clinicStocks?.data ?? [],
            clinicDet?.pharmacyTaxId
          )?.prescriptions,
          issue: "",
        };
        if (reqDet?.prescription?.[0]?.prescriptionId) {
          dispatch(
            updatePrescriptionByIdWoLoader({
              prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
              data,
            })
          );
        } else {
          if (reqDet?.appointment?.appointmentId) {
            dispatch(
              createPrescriptionWoLoader({
                appointmentId: reqDet?.appointment?.appointmentId,
                data,
              })
            );
          }
        }
      }
    }
    if (selectedItem) {
      if (procedValues?.actionType === "Administer") {
        dispatch(
          updateProcedureById({ id: selectedItem?.procedureId, data })
        ).then((res) => {
          if (res?.payload) {
            if (
              procedValues?.actionType === "Administer" &&
              procedValues?.nextDosage
            ) {
              data.doneAt = moment(new Date(procedValues?.nextDueDate)).format(
                "YYYY-MM-DD"
              );
              data.procedureName = procedValues?.procedure;
              data.serviceId = procedValues?.serviceId;
              data.category = procedValues?.category;
              data.subCategory = procedValues?.subCategory;
              data.petId =
                appointment?.appoinment?.petId ?? procedValues?.petId;
              data.status = "Pending";
              data.procedureDetails = [];
              data.appointmentId = null;
              dispatch(createProcedure({ data })).then((res) => {
                if (res?.payload) handleSuccess();
              });
            } else {
              handleSuccess();
            }
          }
        });
      } else {
        dispatch(
          updateProcedureDateAndRemarkById({
            id: selectedItem?.procedureId,
            data: {
              doneAt: moment(new Date(procedValues?.date)).format("YYYY-MM-DD"),
              remarks: procedValues?.remarks,
            },
          })
        ).then((res) => {
          if (res?.payload) handleSuccess();
        });
      }
    } else {
      dispatch(createProcedure({ data })).then((res) => {
        if (res?.payload) {
          if (
            procedValues?.actionType === "Administer" &&
            procedValues?.nextDosage
          ) {
            data.doneAt = moment(new Date(procedValues?.nextDueDate)).format(
              "YYYY-MM-DD"
            );
            data.procedureName = procedValues?.procedure;
            data.serviceId = procedValues?.serviceId;
            data.category = procedValues?.category;
            data.subCategory = procedValues?.subCategory;
            data.petId = appointment?.appoinment?.petId ?? procedValues?.petId;
            data.status = "Pending";
            data.procedureDetails = [];
            data.appointmentId = null;
            dispatch(createProcedure({ data })).then((res) => {
              if (res?.payload) handleSuccess();
            });
          } else {
            handleSuccess();
          }
        }
      });
    }
  };

  const getServiceList = () => {
    return services?.data
      ?.filter(
        (sl) =>
          !["lab", "radiology", "diagnostics"].includes(
            sl?.category?.toLowerCase()
          )
      )
      ?.map((ser) => ({
        name: ser?.serviceName,
        value: ser?.serviceName,
        serviceId: ser?.serviceId,
        category: ser?.category,
        subCategory: ser?.subCategory,
      }));
  };

  const handleEdit = (det) => {
    const reqObj = {
      ...procedValues,
      serviceId: det?.serviceId,
      procedure: det?.procedureName,
      date: new Date(det?.doneAt),
      remarks: det?.remarks,
    };
    const vrnts = getVarinatList(det?.serviceId)?.find(
      (li) =>
        li?.variantId === det?.procedureVariantId ||
        li?.name === det?.serviceType
    );
    if (vrnts) {
      reqObj.variant = vrnts?.value ?? det?.serviceType;
      reqObj.variantId = vrnts?.variantId ?? det?.procedureVariantId;
    }
    setProcedValues(reqObj);
    setSelectedItem(det);
    setModVsble(true);
  };

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div className="flex-row-ali-cen mt20">
          <Typography className="font-bold fs14">Preventive History</Typography>
        </div>
        <div className="flex-row-ali-cen">
          {apntId &&
          procedure?.data?.filter(
            (li) => !li?.appointmentId && li?.isFromPreventive
          )?.length > 0 ? (
            procedure?.data
              ?.filter((li) => !li?.appointmentId && li?.isFromPreventive)
              ?.slice(0, 5)
              ?.map((pl, i) => (
                <div
                  key={pl?.procedureId}
                  className="w30Per flex-column pl10 mt10"
                  style={{
                    borderRight:
                      i !==
                      procedure?.data?.filter(
                        (li) => !li?.appointmentId && li?.isFromPreventive
                      )?.length -
                        1
                        ? "1px solid #ddd"
                        : "none",
                  }}
                >
                  <div className="flex-column">
                    <Typography className="txt-semi-bold black2 fs12 mt10">
                      {pl?.procedureName}
                    </Typography>
                    {pl?.doneAt ? (
                      <div className="flex-row-ali-cen mt10">
                        <div className="gray-dot2" />
                        <Typography className="txt-semi-bold fs10 ml5 orange2">
                          Date: {moment(pl?.doneAt).format("DD MMM YYYY")}
                        </Typography>
                      </div>
                    ) : null}
                  </div>
                  <Typography
                    className={`txt-semi-bold fs12 mt10 ph10pv3 br5 width-fit-con ${
                      new Date(pl?.doneAt) >
                      new Date(new Date().setHours(0, 0, 0, 0))
                        ? "orange3"
                        : "red3"
                    } ${
                      new Date(pl?.doneAt) >
                      new Date(new Date().setHours(0, 0, 0, 0))
                        ? "orange-back"
                        : "red-back6"
                    }`}
                  >
                    {new Date(pl?.doneAt) >
                    new Date(new Date().setHours(0, 0, 0, 0))
                      ? pl?.status
                      : "Overdue"}
                  </Typography>
                  <Typography
                    className="blue-color fs12 txt-semi-bold underline cursor mt10"
                    onClick={() => handleEdit(pl)}
                  >
                    View
                  </Typography>
                </div>
              ))
          ) : (
            <div className="no-rec h50">No records available</div>
          )}
        </div>
      </Grid>

      <CustomModal
        open={modVsble}
        onClose={handleModClose}
        header={selectedItem ? "Update" : "Add"}
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20 mt10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <Typography className="font-medium fs14">
                  Select your action
                </Typography>
                <span className="red-color ml2"> *</span>
              </div>
              <CustomCheckbox
                radio
                name="actionType"
                onChange={(e) => onChange("actionType", e?.target?.value)}
                radios={
                  (reqDet?.appointment?.appointmentId &&
                    (reqDet?.appointment?.inpatient ||
                      reqDet?.appointment?.appointmentStatus !==
                        "scheduled")) ||
                  reqDet?.appointment?.appointmentStatus === "consultation" ||
                  reqDet?.appointment?.appointmentStatus === "finalize"
                    ? radioActionTypes
                    : radioActionScheduleOnly
                }
                defaultValue={procedValues?.actionType}
              />
              <div className="mbminus" />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="red-back4 br5 ph20 pv10 flex-row-between-align-center">
                <Typography className="red14 fs14 txt-semi-bold">
                  Cost
                </Typography>
                <Typography className="red14 fs14 txt-semi-bold">
                  Rs. {getCost(procedValues?.serviceId)}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">
                Procedure Name <span className="red-color">*</span>
              </Typography>
              <CustomSelect
                list={getServiceList()}
                value={procedValues?.procedure}
                handleChange={(value) => onChange("procedure", value)}
                error={!!procedErrs?.procedure}
                helperText={procedErrs?.procedure}
                addNewSelect
                searchOnly
                disabled={selectedItem}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">
                Variant <span className="red-color">*</span>
              </Typography>
              <CustomSelect
                list={getVarinatList(procedValues?.serviceId)}
                value={procedValues?.variant}
                handleChange={(value) => onChange("variant", value)}
                error={!!procedErrs?.variant}
                helperText={procedErrs?.variant}
                addNewSelect
                searchOnly
                disabled={selectedItem}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                label="Date"
                labelTop
                fullWidth
                handleChange={(e) => onChange("date", e?.target?.value)}
                value={procedValues?.date}
                mobileDate
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">Remarks</Typography>
              <CustomTextField
                fullWidth
                handleChange={(e) => onChange("remarks", e?.target?.value)}
                value={procedValues?.remarks}
                multiline
              />
            </Grid>
            {procedValues?.actionType === "Administer" ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="flex-row-ali-cen">
                  <Typography className="font-medium fs14">
                    Schedule for the next dosage?
                  </Typography>
                  <span className="red-color ml2"> *</span>
                </div>
                <CustomCheckbox
                  radio
                  name="nextDosage"
                  onChange={(e) => onChange("nextDosage", e?.target?.value)}
                  radios={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                  defaultValue={procedValues?.nextDosage}
                />
                <div className="mbminus" />
              </Grid>
            ) : null}
            {procedValues?.actionType === "Administer" &&
            procedValues?.nextDosage ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <CustomTextField
                  name="nextDueDate"
                  label={nameExpan?.["nextDueDate"]}
                  fullWidth
                  handleChange={(e) =>
                    onChange("nextDueDate", e?.target?.value)
                  }
                  value={procedValues?.nextDueDate}
                  mobileDate
                  mandatoryField
                  labelTop
                  minDate={datePlusOneDay}
                />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-end">
                <div>
                  <CustomButton
                    text="Save"
                    smallBtn
                    onClick={handleSaveUpdate}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default PreventiveHistory;
